import { useArticles } from "./useArticles";
export var useTermsPrivacyAndSecurityArticles = function useTermsPrivacyAndSecurityArticles() {
  var articles = useArticles();
  return [articles.FAQ.EU_DSA, articles.FAQ.FAIRE_ACCOUNT_SECURITY, articles.BrandTermsAndPolicies.BRAND_POLICIES];
};